export default "__VITE_ASSET__a4c19885__"